import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AdminDataCreateDto } from '../dtos/admindata/adminDataCreateDto';
import { AdminDataUpdateDto } from '../dtos/admindata/adminDataUpdateDto';
import { CreateFamilyMembershipDto , UpdateFamilyMembershipDto } from '../dtos/familymembership/familyMembersipDto';
@Injectable({
  providedIn: 'root'
})
export class FamilyMembershipService {

  private apiUrl = `${environment.apiUrl}/familymembership`; // API URL'si

  constructor(private http: HttpClient) {}

  getList(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  getByCountryId(countryId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${countryId}`);
  }

  create(entity: CreateFamilyMembershipDto): Observable<any> {
    return this.http.post(`${this.apiUrl}`, entity);
  }

  update(id: number, entity: UpdateFamilyMembershipDto): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, entity);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
